<div class="card mb-0 mt-3">
    <div class="card-body">
        <div class="row">
            <div class="col-auto">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" placeholder="검색어"
                        [(ngModel)]="searchValue"
                        (keyup.enter)="keyupEnterSearchValue($event)">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                            (click)="clickSearch()">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                검색
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="dtgTeamId"
                    (ngModelChange)="changeTeamInfo($event)">
                    <option [ngValue]="''" *ngIf="userGroupId <= 100">전체그룹</option>
                    <option [ngValue]="'undefined'">미설정</option>
                    <option *ngFor="let item of listTeam;"
                        [ngValue]="item.dtgTeamId">
                        {{item.dtgTeamNm}}
                    </option>
                </select>
            </div> -->
            <div class="col-auto">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" placeholder="차량선택"
                        [(ngModel)]="dtgCarNo"
                        (click)="clickOpenModalGeofenceCarList(DtgActionType.read)"
                        readonly>
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                            (click)="clickOpenModalGeofenceCarList(DtgActionType.read)">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                차량검색
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div class="col-auto">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <label class="input-group-text">
                            <i class="mdi mdi-file-tree"></i>
                            <span class="ml-1">
                                회차
                            </span>
                        </label>
                    </div>
                    <input type="number"
                        class="form-control form-control-sm"
                        style="width: 80px;"
                        [(ngModel)]="runCnt"
                        min="1"
                        (ngModelChange)="changeRunCnt($event)"
                        readonly>
                </div>
            </div> -->
            <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="shapeType"
                    (ngModelChange)="changeShapeType($event)">
                    <option [value]="''">전체형태</option>
                    <option [value]="'C'">원형</option>
                    <option [value]="'R'">사각형</option>
                    <option [value]="'P'">다각형</option>
                </select>
            </div>
            <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="actType"
                    (ngModelChange)="changeActType($event)">
                    <option [value]="''">전체출입</option>
                    <option [value]="'I'">진입</option>
                    <option [value]="'O'">이탈</option>
                </select>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-success"
                    (click)="exportExcel()">
                    <i class="fas fa-file-excel"></i>
                    <span class="ml-1">엑셀출력</span>
                </button>
            </div>
        </div>
        
        <div class="table-responsive mt-3">
            <table class="table table-sm table-hover align-items-center mb-0">
                <thead class="">
                    <!-- <th>
                        그룹이름
                    </th> -->
                    <th>
                        차량번호
                    </th>
                    <th>
                        설정이름
                    </th>
                    <th>
                        설정형태
                    </th>
                    <th>
                        출입여부
                    </th>
                    <th>
                        발생일시
                    </th>
                    <th [hidden]="listType === DtgListType.modal">
                        편집
                    </th>
                </thead>
                <tbody class="">
                    <tr *ngFor="let item of listGeofence;">
                        <!-- <td>
                            <span [hidden]="!item.dtgTeamNm">{{item.dtgTeamNm}}</span>
                            <span [hidden]="item.dtgTeamNm" class="text-warning">미설정</span>
                        </td> -->
                        <td>
                            <span>{{item.dtgCarNo}}</span>
                        </td>
                        <td>
                            <button type="button" class="btn btn-sm btn-link px-0"
                                (click)="clickOpenModalGeofenceInfo(DtgActionType.read,item)">
                                <span>{{item.geoFenceNm}}</span>
                            </button>
                        </td>
                        <td [ngSwitch]="item.shapeType">
                            <span *ngSwitchCase="'C'">원형</span>
                            <span *ngSwitchCase="'R'">사각형</span>
                            <span *ngSwitchDefault>다각형</span>
                        </td>
                        <td [ngSwitch]="item.actType">
                            <span *ngSwitchCase="'I'">진입</span>
                            <span *ngSwitchCase="'O'">이탈</span>
                            <span *ngSwitchDefault>중립</span>
                        </td>
                        <td>
                            <span>{{item.dtgRegDt}}</span>
                        </td>
                        <td [hidden]="listType === DtgListType.modal">
                            <button type="button" class="btn btn-sm btn-outline-secondary"
                                (click)="clickOpenModalGeofenceHisPosition(DtgActionType.read,item)">
                                <i class="mdi mdi-crosshairs-gps"></i>
                                <span class="ml-1">위치보기</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <div class="mt-3">
            <list-paging
                [inputPagingInfo]="pagingInfo"
                (callbackClickPageNumber)="callbackClickPageNumber($event)"
                (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
        </div>
    </div>
</div>

<div class="text-warning bg-white shadow-sm p-2 mt-3 small">
    <div class="">
        <i class="far fa-bell mr-2"></i>
        <span>자료는 1일전 까지만 집계되어 표시됩니다</span>
    </div>
    <div class="mt-2">
        <i class="far fa-bell mr-2"></i>
        <span>페이지 진입시 데이터가 자동으로 표시되지 않으며 검색버튼을 눌러야 표시됩니다</span>
    </div>
</div>